var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-editor"},[_c('textarea',{attrs:{"id":"editor1","name":"editor1","cols":"30","rows":"10"}})])}]

export { render, staticRenderFns }